import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import "./styles/base.css";
// Retunes the token layer to the hero's drafting language. Must follow
// base.css; everything after it inherits the new palette automatically.
import "./styles/theme.css";
import "./styles/components.css";
import "./brand/logo.css";
import "./styles/pages.css";
import "./styles/marketplace.css";
import "./styles/responsive.css";
import "./styles/app.css";
// Line weights, square corners and drafting marks — the things a token
// cannot express. Must follow the prototype stylesheets it corrects.
import "./styles/engineering.css";
// Hero & navigation from the approved design canvas. timeline.css is
// generated from timeline.json — see scripts/build-hero.sh.
import "./components/hero/timeline.css";
import "./components/hero/hero.css";
// The content console. Same tokens as the site, denser layout.
import "./admin/admin.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
